import React from 'react';
import { observer } from 'mobx-react';
import { Route, Link } from 'react-router-dom';
import CalculationContainer from './containers/CalculationContainer';
import OverviewContainer from './containers/OverviewContainer';
import MaximumMortgageContainer from './containers/MaximumMortageContainer';
import RouterWrapperComponent from './RouterWrapperComponent';
import DisclaimerComponent from './components/footer/DisclaimerComponent';
import FooterComponent from './components/footer/FooterComponent';
import WithTrackerComponent from './components/hocs/WithTrackerComponent';
import ModalComponent from './components/shared_components/ModalComponent';
import RouterData from './stores/RouterStore';
import CalculationFormData from './stores/CalculationFormStore';
import CalculationOutputData from './stores/CalculationOutputStore';
import OverviewData from './stores/OverviewStore';
import FaqContainer from './containers/FaqContainer';
import RouterWithProvider from './RouterWithProvider';
import ComparisonComponent from './containers/ComparisonContainer';
import ComparisonFormData from './stores/ComparisonFormStore';
import AboutContainer from './containers/AboutContainer';
import VideoContainer from './containers/VideoContainer';

@observer
class App extends React.Component {
  constructor(props) {
    super(props);

    this.resetLabelIdFromUrl = this.resetLabelIdFromUrl.bind(this);
  }

  resetLabelIdFromUrl() {
    CalculationFormData.labelIdFromUrl.active = true;
  }

  render() {
    const styles = {
      fontSize: 14,
    };

    /* Custom stores */
    const stores = {
      ComparisonFormData,
      CalculationFormData,
      CalculationOutputData,
      OverviewData,
    };

    return (
      <RouterWithProvider stores={stores}>
        <div>
          <div className="navbar">
            <a href="/">
              <span style={styles}><img
                src="/images/looptijdrente-logo.png"
                alt="looptijdrente logo"
              /></span>
            </a>
            <ul className="nav-items">
              <li>
                <Link
                  className={RouterData.activeRoute === '/' ? 'bold' : ''}
                  to="/"
                >
                    Overzicht
                  </Link>
              </li>
              <li>
                <Link
                  className={RouterData.activeRoute.indexOf('bereken') !== -1 ? 'bold' : ''}
                  onClick={this.resetLabelIdFromUrl}
                  to="/bereken"
                >
                    Bereken maandlasten
                  </Link>
              </li>
              <li>
                <Link
                  className={RouterData.activeRoute.indexOf('vergelijk') !== -1 ? 'bold' : ''}
                  to="/vergelijk"
                >
                  Vergelijk verstrekkers
                </Link>
              </li>
              <li>
                <Link
                  className={RouterData.activeRoute === '/maximale-hypotheek' ? 'bold' : ''}
                  to="/maximale-hypotheek"
                >
                   Bereken maximale hypotheek
                  </Link>
              </li>
              <li>
                <Link
                  className={RouterData.activeRoute === '/faq' ? 'bold' : ''}
                  to="/faq"
                >
                    FAQ
                  </Link>
              </li>
              <li>
                <Link
                  className={RouterData.activeRoute === '/over-ons' ? 'bold' : ''}
                  to="/over-ons"
                >
                  Over ons
                </Link>
              </li>
              <li>
                <a
                  href="https://www.hypotheekadviseurzoeker.nl/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                    Zoek adviseur
                  </a>
              </li>
            </ul>
          </div>
          <ModalComponent />
          <Route
            exact
            path={'/'}
            component={WithTrackerComponent(() => (
              <RouterWrapperComponent>
                <OverviewContainer />
              </RouterWrapperComponent>
              ))}
          />
          <Route
            path={'/bereken/:labelId?'}
            component={WithTrackerComponent(() => (
              <RouterWrapperComponent>
                <CalculationContainer />
              </RouterWrapperComponent>
              ))}
          />
          <Route
            path={'/vergelijk/:labelId?'}
            component={WithTrackerComponent(() => (
              <RouterWrapperComponent onChangeHandler={this.setActivePathName}>
                <ComparisonComponent />
              </RouterWrapperComponent>
            ))}
          />
          <Route
            path={'/maximale-hypotheek'}
            component={WithTrackerComponent(() => (
              <RouterWrapperComponent>
                <MaximumMortgageContainer />
              </RouterWrapperComponent>
              ))}
          />
          <Route
            path={'/over-ons'}
            component={WithTrackerComponent(() => (
              <RouterWrapperComponent>
                <AboutContainer />
              </RouterWrapperComponent>
            ))}
          />
          <Route
            path={'/faq'}
            component={WithTrackerComponent(() => (
              <RouterWrapperComponent onChangeHandler={this.setActivePathName}>
                <FaqContainer />
              </RouterWrapperComponent>
              ))}
          />
          <Route
            path={'/radar'}
            component={WithTrackerComponent(() => (
              <RouterWrapperComponent>
                <VideoContainer />
              </RouterWrapperComponent>
            ))}
          />

          <DisclaimerComponent />
          <FooterComponent />

        </div>
      </RouterWithProvider>
    );
  }
}

export default App;
